import RepositoryService from 'src/services/repository'

const resource = 'partType'

export default {
  ...RepositoryService.utils.createCrudRepository(resource),
}
